import { render, staticRenderFns } from "./CustomerImportForm.vue?vue&type=template&id=036f5169&scoped=true"
import script from "./CustomerImportForm.vue?vue&type=script&lang=js"
export * from "./CustomerImportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036f5169",
  null
  
)

export default component.exports